export default __webpack_public_path__ + "static/media/fauna-desktop-wireframe.a88906a2.png";